/**
 * Select Component
 *
 *   <Select value={id} onChange={(e) => setId(e.target.value)}>
 *     <option value="a">항목 A</option>
 *   </Select>
 *
 *   <Select options={[{ value: 'a', label: '항목 A' }]} value={id} onChange={...} />
 *
 * - size: sm | md(기본)
 * - 그 외 <select> 속성(disabled, name 등) 그대로 전달
 */

import { ReactNode, SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options?: SelectOption[];
  size?: 'sm' | 'md';
}

export function Select({ options, size = 'md', className = '', children, ...props }: SelectProps) {
  return (
    <select className={`select select--${size} ${className}`.trim()} {...props}>
      {options
        ? options.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))
        : children}
    </select>
  );
}

export default Select;
